<script>
  import imageCompression from "browser-image-compression";
  import TextInput from "../UI/TextInput.svelte";
  import Button from "../UI/Button.svelte";
  import Spinner from "../UI/Spinner.svelte";
  import Modal from "../UI/Modal.svelte";
  import { fade } from "svelte/transition";
  import { createEventDispatcher } from "svelte";
  import { isEmpty, isValidEmail } from "../helpers/validation.js";

  const dispatch = createEventDispatcher();

  let selfie = "";
  let selfieData = null;
  let fileSizeDisplay = 0;
  let imageLoading = false;

  // https://stackoverflow.com/questions/17710147/image-convert-to-base64#answer-17711190
  // function readFile(event) {
  //   const files = event.target.files;

  //   if (files && files[0]) {
  //     if (files[0].size > 1000000) {
  //       let fileInMb = files[0].size / 1000000;
  //       fileSizeDisplay = fileInMb.toFixed(1) + " MB";
  //       fileTooLarge = true;
  //       return;
  //     }

  //     let FR = new FileReader();

  //     FR.addEventListener("load", function(e) {
  //       selfie = e.target.result;
  //     });

  //     FR.readAsDataURL(files[0]);
  //     // console.log(files[0].size);
  //   }
  // }

  async function handleImageUpload(event) {
    imageLoading = true;
    const imageFile = event.target.files[0];
    console.log("originalFile instanceof Blob", imageFile instanceof Blob); // true
    console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

    const options = {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    };
    try {
      const compressedFile = await imageCompression(imageFile, options);
      console.log(
        "compressedFile instanceof Blob",
        compressedFile instanceof Blob
      ); // true
      console.log(
        `compressedFile size ${compressedFile.size / 1024 / 1024} MB`
      ); // smaller than maxSizeMB

      // https://stackoverflow.com/questions/17710147/image-convert-to-base64#answer-17711190
      let FR = new FileReader();

      FR.addEventListener("load", function(e) {
        selfie = e.target.result;
        console.log("loaded");
      });

      FR.readAsDataURL(compressedFile);

      imageLoading = false;
    } catch (error) {
      console.log(error);
    }
  }

  function convertImage(imageSrc, imageFile) {
    let FR = new FileReader();

    FR.addEventListener("load", function(e) {
      selfie = imageSrc;
      console.log("loaded");
    });

    FR.readAsDataURL(imageFile);
  }

  function getPositionCode(positionName) {
    let positionCode = "";

    switch (positionName.toUpperCase()) {
      case "CENTRE":
        positionCode = "C";
        break;
      case "CENTER":
        positionCode = "C";
        break;
      case "LEFT WING":
        positionCode = "L";
        break;
      case "RIGHT WING":
        positionCode = "R";
        break;
      case "DEFENCE":
        positionCode = "D";
        break;
      case "DEFENCEMAN":
        positionCode = "D";
        break;
      case "DEFENSE":
        positionCode = "D";
        break;
      case "DEFENSEMAN":
        positionCode = "D";
        break;
      case "GOALIE":
        positionCode = "G";
        break;
      default:
        break;
    }
    return positionCode;
  }

  let id = "";
  let name = "";
  let positionName = "";
  let positionCode = "";
  let height = "";
  let weight = "";
  let jerseyNumber = "";
  let birthDate = "";
  let birthCity = "";
  let birthCountry = "";

  $: nameValid = !isEmpty(name);
  $: positionValid = !isEmpty(positionName);
  $: heightValid = !isEmpty(height);
  $: weightValid = !isEmpty(weight);
  $: jerseyNumberValid = !isEmpty(jerseyNumber);
  $: birthDateValid = !isEmpty(birthDate);
  $: birthCityValid = !isEmpty(birthCity);
  $: birthCountryValid = !isEmpty(birthCountry);
  $: selfieValid = !isEmpty(selfie);
  $: isFormValid =
    nameValid &&
    positionValid &&
    heightValid &&
    weightValid &&
    jerseyNumberValid &&
    birthDateValid &&
    birthCityValid &&
    birthCountryValid &&
    selfie;

  function submitForm() {
    positionCode = getPositionCode(positionName);

    const fullName = name.split(" ");
    const firstName = fullName[0];
    const lastName = fullName[1];

    selfieData = {
      id: 2,
      name,
      firstName,
      lastName,
      positionName,
      positionCode,
      selfie,
      height,
      weight,
      jerseyNumber,
      birthDate,
      birthCity,
      birthCountry
    };

    saveSelfieDataToLocalStorage(selfieData);

    dispatch("add", selfieData);
  }

  function saveSelfieDataToLocalStorage(selfieData) {
    const selfieJson = JSON.stringify(selfieData);
    window.localStorage.setItem("selfieCard", selfieJson);
  }
</script>

<style lang="scss">
  @import "../style/theme-config.scss";
  .tip {
    color: $opeechee-blue;
  }

  .preview {
    img {
      max-width: 139px;
      max-height: 146px;
      border: 2px solid $opeechee-blue;
      border-radius: 139px 146px;
    }
  }

  .underline {
    text-decoration: underline !important;
  }

  legend {
    font-size: 1.35rem;
  }
</style>

<Modal title="Create Your Own Card!" on:cancel>
  <form>
    <fieldset>
      <legend>Step 1: Add your photo</legend>
      <Button type="file" on:change={handleImageUpload}>Add your photo</Button>
      <p class="tip">
        <strong>Tip:</strong>
        For best results, take a phone selfie at <a class="underline" href="https://remove.bg" target="_blank">remove.bg</a>. Make sure that it's portrait orientation and cropped tight. Download the low-res version, and then upload it from your Files folder.
      </p>
      {#if imageLoading}
        <Spinner />
      {:else if selfie}
        <div class="preview">
          <img
            class="selfie"
            src={selfie}
            id="img"
            height="150"
            alt=""
            transition:fade />
        </div>
        <br />
      {/if}
    </fieldset>
    <fieldset>
      <legend>Step 2: Add card info</legend>
      <TextInput
        id="name"
        label="Name"
        valid={nameValid}
        validityMessage="Please enter your name."
        bind:value={name}
        placeholder="Wayne Gretzky"
        on:input={event => (name = event.target.value)} />
      <TextInput
        id="position"
        label="Position"
        valid={positionValid}
        validityMessage="Please enter your position."
        bind:value={positionName}
        placeholder="Center"
        on:input={event => (positionName = event.target.value)} />
      <TextInput
        id="jersey-number"
        label="Jersey Number"
        valid={jerseyNumberValid}
        validityMessage="Please enter your jersey number."
        bind:value={jerseyNumber}
        placeholder="99"
        on:input={event => (jerseyNumber = event.target.value)} />
      <TextInput
        id="height"
        label="Height*"
        valid={heightValid}
        validityMessage="Please enter your height."
        bind:value={height}
        placeholder="6'"
        on:input={event => (height = event.target.value)} />
      <TextInput
        id="weight"
        label="Weight*"
        valid={heightValid}
        validityMessage="Please enter your weight."
        bind:value={weight}
        placeholder="185"
        on:input={event => (weight = event.target.value)} />
      <TextInput
        id="birthdate"
        label="Date of Birth*"
        valid={birthDateValid}
        validityMessage="Please enter your date of birth."
        bind:value={birthDate}
        placeholder="Jan 26 1961"
        on:input={event => (birthDate = event.target.value)} />
      <TextInput
        id="birthCity"
        label="Birth City"
        valid={birthCityValid}
        validityMessage="Please enter your city of birth."
        bind:value={birthCity}
        placeholder="Brantford"
        on:input={event => (birthCity = event.target.value)} />
      <TextInput
        id="birthCountry"
        label="Birth Country"
        valid={birthCountryValid}
        validityMessage="Please enter your country of birth."
        bind:value={birthCountry}
        placeholder="Canada"
        on:input={event => (birthCountry = event.target.value)} />
      <p>
        <em>
          <small>* Feel free to lie</small>
        </em>
      </p>
    </fieldset>
  </form>

  <div slot="footer">
    <Button
      type="button"
      className="outline"
      on:click={() => dispatch('cancel')}>
      Cancel
    </Button>
    <Button type="button" on:click={submitForm} disabled={!isFormValid}>
      Save
    </Button>
    {#if id}
      <Button type="button" on:click>Delete</Button>
    {/if}
  </div>
</Modal>
